import { MeetingState } from './types';
import { STORAGE_KEY_ENUM } from 'enums';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: MeetingState = {
  meetingMode: localStorage.getItem(STORAGE_KEY_ENUM.MEETING_MODE) === 'true' || false,
  blurActive: false,
};

export const meetingSlice = createSlice({
  initialState,
  name: 'meeting',
  reducers: {
    toggleMeetingMode(state) {
      state.meetingMode = !state.meetingMode;

      if (!state.meetingMode) {
        state.blurActive = false;
      }

      localStorage.setItem(STORAGE_KEY_ENUM.MEETING_MODE, state.meetingMode ? 'true' : 'false');
    },

    setBlurActive(state, action: PayloadAction<boolean>) {
      state.blurActive = action.payload;

      if (!state.meetingMode) {
        state.blurActive = false;
      }

      localStorage.setItem(STORAGE_KEY_ENUM.MEETING_MODE, state.meetingMode ? 'true' : 'false');
    },
  },
});

export const { toggleMeetingMode, setBlurActive } = meetingSlice.actions;

export default meetingSlice.reducer;
